import ChipInspectionResultStatus from '@/components/chip/ChipInspectionResultStatus';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { getPeriodTypeData } from '@/constants/options/period-type.option';
import { getReportTypeStatusData } from '@/constants/options/report-type.option';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import type { PeriodTypeEnum } from '@/types/enums/period-type.enum';
import type { ReportTypeEnum } from '@/types/enums/report-type.enum';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: 'Mã',
        editable: false,
        sortable: false,
        minWidth: 150,
        renderCell: params => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'checklist',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.checklist} />,
    },
    {
        field: 'periodType',
        headerName: 'Chu kỳ kiểm tra',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        cellClassName: 'verticalCenter',
        renderCell: params => {
            const value = params.value as PeriodTypeEnum;

            const label = getPeriodTypeData({
                status: value,
                showChip: false,
            })?.label;

            return label || '-:-';
        },
    },
    {
        field: 'inspectionDate',
        headerName: 'Ngày tiến hành',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={dateUtils.getDate(params.row?.inspectionDate)}
            />
        ),
    },
    {
        field: 'user',
        headerName: 'Người phụ trách',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row?.appUser?.fullname}>
                <EntityDetailButton
                    text={params.row?.appUser?.fullname}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.appUser?.id}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'reportType',
        headerName: 'Loại báo cáo',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        cellClassName: 'verticalCenter',
        renderCell: params => {
            const value = params.value as ReportTypeEnum;

            const label = getReportTypeStatusData({
                status: value,
                showChip: false,
            })?.label;

            return label || '-:-';
        },
    },
    {
        field: 'inspectionResult',
        headerName: 'Kết quả kiểm tra',
        minWidth: 200,
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => (
            <ChipInspectionResultStatus status={params.row?.inspectionResult} />
        ),
    },
];
